import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

/**
 * Hover/focus info icon used beside the headings on the 835 Import & Conversion page.
 *
 * Follows the icon pattern already used elsewhere in the app (see SCCEvaluationForm.js), with
 * one deliberate difference: that one opens on click, these open on hover.
 *
 * The trigger is a focusable span rather than the `<i>` itself. An `<i>` cannot take focus, so
 * hanging the trigger directly off it would leave the explanation reachable by mouse only.
 * Pairing "focus" with "hover" keeps it available to keyboard and screen-reader users.
 */
export default function InfoTooltip({ id, label, text, placement = "right" }) {
  return (
    <OverlayTrigger
      placement={placement}
      trigger={["hover", "focus"]}
      overlay={
        <Tooltip id={id} className="import-conversion-835-tooltip">
          {text}
        </Tooltip>
      }
    >
      <span
        className="import-conversion-835-info-trigger"
        tabIndex={0}
        role="button"
        aria-label={label}
      >
        <i
          className="additional-info-popover-icon fa fa-info-circle"
          aria-hidden="true"
        />
      </span>
    </OverlayTrigger>
  );
}
